module.exports = __webpack_public_path__ + "img/logo_old.37d1fb45.png";